/* Decottaa teması – sayfa aşağı kaydırıldıkça bölümlerin yumuşakça belirmesi. */
(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  // Sabit konumlu öğe taşıyan bölümler (ürün, sepet) dönüşümden etkilenmesin diye atlanır
  const skip = 'product-info, cart-page, sticky-atc';
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  document.querySelectorAll('#MainContent > .shopify-section').forEach((section) => {
    if (section.querySelector(skip)) return;
    // İlk ekranda görünen bölümler beklemeden gösterilir
    if (section.getBoundingClientRect().top < window.innerHeight) return;
    section.classList.add('reveal');
    observer.observe(section);
  });
})();
